import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Button, Checkbox, Input, Space, Spin, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { 
  Container, 
  PokeList, 
  PokeItem, 
  ItemCard, 
  BallImg, 
  PokeImg, 
  ItemData, 
  PokeTipo,
  Row
} from "./styles"
import { LoadingOutlined } from '@ant-design/icons';

import pokeballImage from "../../../Assets/pokeball.png"
import { useListaPokemon } from '../../../Hooks/Player';
import useScrollEnd from '../../../Hooks/useScrollEnd';

const { Title, Paragraph } = Typography;

export const Pokedex = () => {
  const [pokedata, setPokedata] = useState([]);
  const [page, setPage] = useState(pokedata.length > 0 ? (Math.round(pokedata.length/10)+1) : 1);
  const [firstFetch, setFetch] = useState(pokedata.length == 0);
  const [check, setCheck] = useState(true)
  const [sPokemon, setSPokemon] = useState("");
  const [imageCache, setImageCache] = useState({});

  const {data, refetch, isFetching} = useListaPokemon({"perPage": 1000, "page": page, "filtro": sPokemon}, firstFetch, setPage);

  useEffect(() => {
    if(page == 1) {
      data && setPokedata(data)
    } else {
      data && setPokedata([...pokedata, ...data])
    }
  }, [isFetching])

  //funcion a realizar cuando se detecte el final del scroll
  const onScrollEnd = () => {
    refetch()
  };

  //customHook para detectar final de scroll en Y
  // const scrollRef = useScrollEnd(onScrollEnd);

  // search
  const searchPokemon = () => {
    setPage(1);
    setPokedata([]);
  }  

  useEffect(() => {
    if (!Object.keys(pokedata).length > 0) {
      refetch(); // Hacer refetch una vez que el state esté actualizado
    }
  }, [pokedata]);

  
  useEffect(() => {
    const cache = {};
    data && data.forEach(item => {
        const url = item.imagPokemon;
        const img = new Image();
        img.src = url;
        cache[item.id] = img.src;
    });
    setImageCache(cache);
}, [data]);

  const storedDataUser = JSON.parse(localStorage.getItem('dataUser'));
  return (
    <Container> 
      <Typography direction="vertical" style={{ marginTop: "5%", marginLeft: "5%" }}>
        <Row>
          <Title level={1} style={{ marginTop: "0%", fontFamily: "POKEFONT" }} >Pokédex</Title>
          <Checkbox onChange={() => setCheck(prev => !prev)}>Sólo capturados</Checkbox>
        </Row>
        <Paragraph style={{ marginTop: "-15px" }} >Busca un Pokémon por nombre o usando su número de Pokédex nacional. </Paragraph>
      </Typography>
      <Space.Compact style={{ width: "90vw" }}>
        <Input size="large" placeholder="Qué Pokémon estás buscando?" prefix={<SearchOutlined />} style={{ borderRadius: "25px 0 0 25px" }} onChange={(e) => setSPokemon(e.target.value)}/>
        <Button size="large" style={{ borderRadius: "0 25px 25px 0", width: "20%", backgroundColor: "rgb(44, 62, 80)", color: "white" }} onClick={searchPokemon}>Buscar</Button>
      </Space.Compact>
      <PokeList>
      {
        pokedata != [] && pokedata[0] && pokedata.filter(item => !check ? item.capturado : item).map( (item, index) => <PokeItem key={index}><PokedexItem data={item} imageCache={imageCache} /></PokeItem>)
      }
      {
        isFetching && 
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px"}}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      }
      </PokeList>
    </Container>
  )
}

const PokedexItem = ({data, imageCache}) => {
  return (
    <Link to={data.capturado ? `detalle?n_pokedex=${data.numero_pokedex}` : "#"}>
      <ItemCard color={data.colorCard} capturado={data.capturado.toString()}>
        
        <BallImg src={pokeballImage}/>
        <PokeImg src={imageCache[data.id]} capturado={data.capturado.toString()} loading="lazy"/>

        <ItemData>
          <Title style={{ color: "rgb(247, 247, 247)", fontFamily: "POKEFONT" }} level={5} italic>{`#${data.numero_pokedex.toString().padStart(3, "0")}`}</Title>
          <Title style={{ color: "white", marginTop: "-15px", fontFamily: "POKEFONT" }} level={2}>{data.capturado ? data.nombre : "???"}</Title>
          <PokeTipo src={ data.capturado ? data.imagTipoP : "" } />
        </ItemData>
      </ItemCard>
    </Link>
  )
}
